// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Audit from "@material-ui/icons/TrackChanges";
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import NotFound from "views/NotFound/Index.jsx";


const dashboardRoutes = [
    {
        path: "/landing",
        sidebarName: "Home",
        navbarName: "Home",
        icon: Dashboard,
        component: DashboardPage,
        subMenu: [],

    },
    {
        path: "/app",
        sidebarName: "Dashboard",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },
    {
        path: "/app/dashboard",
        sidebarName: "Dashboard",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },

    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/executiveUser.jsx